export const commonRu = {
  cancel: 'Отмена',
  save: 'Сохранить',
  back: 'Назад',
  done: 'Готово',
  retry: 'Повторить',
  loadError: 'Не удалось загрузить',
} as const;

/**
 * Форма common-каталога: те же ключи, значения — строки (НЕ литералы `typeof commonRu`).
 * Литералы заставили бы `commonEn` иметь ровно те же строковые значения, что и `commonRu`.
 */
export type CommonBundle = Record<keyof typeof commonRu, string>;
